import { Icon } from "@circle-react/components/shared/Icon";
import type { SidebarLink } from "@circle-react/components/Spaces/SidebarV3/LinksSection/LinkItem";
import type { ReactNode } from "react";

import { usePurchaseFlowAnchorProps } from "@/react/helpers/purchaseFlowAnchor";

interface LinkItemContentProps {
  children?: ReactNode;
  link: SidebarLink;
}

export const LinkItemContent = ({ link, children }: LinkItemContentProps) => {
  const purchaseFlowAnchorProps = usePurchaseFlowAnchorProps(
    link.may_lead_to_purchase,
  );

  return (
    <a
      href={link.url}
      target="_blank"
      rel="noreferrer"
      draggable="false"
      title={link.name}
      className="text-c-sidebar hover:text-c-sidebar focus:text-c-sidebar active:text-c-sidebar hover:bg-c-sidebar-hover focus:bg-c-sidebar-hover text-sm h-8.5 group !m-0 flex w-full items-center gap-2 rounded-md px-4 font-medium transition-colors duration-200"
      {...purchaseFlowAnchorProps}
    >
      <span className="flex !h-5 !w-5 items-center justify-center">
        <Icon type="16-external-link" className="!h-4 !w-4" size={16} />
      </span>
      <h4 className="text-sm flex-1 truncate font-medium text-current">
        {link.name}
      </h4>
      {children}
    </a>
  );
};
